import React from 'react';
import { QuoteLocator, VoteOnReactionType } from '../../../lib/voting/namesAttachedReactions';
import classNames from 'classnames';
import UpArrowIcon from '@/lib/vendor/@material-ui/icons/src/KeyboardArrowUp';
import { defineStyles } from '@/components/hooks/defineStyles';
import { useStyles } from '@/components/hooks/useStyles';

const styles = defineStyles('ReactOrAntireactVote', (theme: ThemeType) => ({
  reactOrAntireact: {
    minWidth: 55
  },
  reactionVoteCount: {
    display: "inline-block",
    verticalAlign: "middle",
  },
  voteArrow: {
    color: theme.palette.grey[400],
  },
  voteArrowIcon: {
    fontSize: 'inherit',
    padding: 0,
    width: 24,
    height: 24,
    verticalAlign: "middle",
    cursor: 'pointer'
  },
  voteArrowLeft: {
    transform: 'rotate(-90deg)',
    marginRight: -4,
  },
  voteArrowRight: {
    transform: 'rotate(-270deg)',
    marginLeft: -4,
  },
  colorRed: {
    color: theme.palette.error.main,
  },
  colorGreen: {
    color: theme.palette.primary.main,
  },
}))

const ReactOrAntireactVote = ({reactionName, quote, netReactionCount, currentUserReaction, setCurrentUserReaction}: {
  reactionName: string
  quote: QuoteLocator|null,
  netReactionCount: number
  currentUserReaction: VoteOnReactionType|null
  setCurrentUserReaction: (reactionName: string, reaction: VoteOnReactionType|null, quote: QuoteLocator|null) => void
}) => {
  const classes = useStyles(styles);
  const onClick = (reaction: "reacted"|"disagreed") => {
    if (reaction === "reacted") {
      if (currentUserReaction === "created" || currentUserReaction === "seconded") {
        setCurrentUserReaction(reactionName, null, quote);
      } else {
        setCurrentUserReaction(reactionName, "seconded", quote);
      }
    } else {
      if (currentUserReaction === "disagreed") {
        setCurrentUserReaction(reactionName, null, quote);
      } else {
        setCurrentUserReaction(reactionName, "disagreed", quote);
      }
    }
  }

  return <div className={classes.reactOrAntireact}>
    <ReactionVoteArrow
      orientation="left"
      onClick={() => onClick("disagreed")}
      className={currentUserReaction==="disagreed" ? classes.colorRed : undefined}
    />
    <span className={classes.reactionVoteCount}>
      {netReactionCount}
    </span>
    <ReactionVoteArrow
      orientation="right"
      onClick={() => onClick("reacted")}
      className={(currentUserReaction==="created"||currentUserReaction==="seconded") ? classes.colorGreen : undefined}
    />
  </div>
}

const ReactionVoteArrow = ({orientation, onClick, className}: {
  orientation: "left"|"right",
  onClick: () => void,
  className?: string,
}) => {
  const classes = useStyles(styles);

  return <span className={classes.voteArrow}>
    <UpArrowIcon
      onClick={onClick}
      className={classNames(
        className,
        classes.voteArrowIcon,
        {
          [classes.voteArrowLeft]: orientation==="left",
          [classes.voteArrowRight]: orientation==="right",
        },
      )}
    />
  </span>
}


export default ReactOrAntireactVote;



